import React, { useState, useCallback, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import CKEditor from "ckeditor4-react";

import { makeStyles } from "@material-ui/core/styles";

import Typography from "@material-ui/core/Typography";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Loading from "../../common/Loading";

import { actionCreators as actionCreatorsAdmin } from "../../../_actions/adminActions";

import Button from "components/CustomButtons/Button";

const useStyles = makeStyles(() => ({
  dialogActions: {
    justifyContent: "center"
  }
}));

const AcceptReportDialog = ({
  open,
  content,
  type,
  name,
  year,
  onClose,
  onSave,
  getMailingAddress,
  mailingAddress
}) => {
  const classes = useStyles();
  const [editorData, setEditorData] = useState();

  useEffect(() => {
    if (content) {
      setEditorData(content);
    }
  }, [content]);

  useEffect(() => {
    getMailingAddress();
  }, []);

  useEffect(() => {
    setEditorData(mailingAddress);
  }, [mailingAddress]);

  const [isDirty, setDirty] = useState(false);

  const handleEditorChange = useCallback(evt => {
    setEditorData(evt.editor.getData());
  }, []);

  const handleSave = useCallback(
    type => {
      setDirty(true);
      onSave(type, editorData);
    },
    [editorData]
  );

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        {type === "accept" ? "Accept" : "Reject"} Report
      </DialogTitle>
      <DialogContent>
        <Typography>
          You have chosen to {type === "accept" ? "accept" : "reject"} the{" "}
          {name} report for FY {year}
        </Typography>
        <Typography>
          The message below will be sent to the submitter of the report letting
          them know of this action.
        </Typography>
        <br />
        <Typography>
          Include addtional comments by typing them in the box below
        </Typography>
        <br />
        <Typography>
          The financial report you submitted for {name} has been{" "}
          {type === "accept" ? "accepted" : "rejected"} by ACC. Below are
          comments from ACC.
        </Typography>
        <br />
        <CKEditor data={editorData} onChange={handleEditorChange} />
      </DialogContent>
      <DialogActions classes={{ root: classes.dialogActions }}>
        {isDirty ? (
          <Loading />
        ) : (
          <>
            <Button
              color="success"
              variant="contained"
              onClick={() => handleSave(type)}
            >
              {type === "accept" ? "Accept" : "Reject"}
            </Button>
            <Button color="danger" variant="contained" onClick={onClose}>
              Cancel
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

const mapStateToProps = state => ({
  mailingAddress: state.adminReducer.mailingAddress
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ ...actionCreatorsAdmin }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AcceptReportDialog);
